
import React, { useState, useEffect, useRef } from 'react'; // 1. Import useRef
import { api } from '../../api';


// The timezones array remains the same...
const timezones = [
    { label: '(UTC-12:00) Baker Island', value: -720 },
    { label: '(UTC-11:00) Samoa', value: -660 },
    { label: '(UTC-10:00) Hawaii', value: -600 },
    { label: '(UTC-09:00) Alaska', value: -540 },
    { label: '(UTC-08:00) Pacific Time (PST)', value: -480 },
    { label: '(UTC-07:00) Pacific Time (PDT)', value: -420 },
    { label: '(UTC-07:00) Mountain Time (MDT)', value: -420 },
    { label: '(UTC-06:00) Central Time (US & Canada)', value: -360 },
    { label: '(UTC-05:00) Eastern Time (US & Canada)', value: -300 },
    { label: '(UTC-04:00) Atlantic Time', value: -240 },
    { label: '(UTC-03:00) Greenland', value: -180 },
    { label: '(UTC-00:00) London, Dublin, Lisbon', value: 0 },
    { label: '(UTC+01:00) Berlin, Rome, Paris', value: 60 },
    { label: '(UTC+02:00) Athens, Istanbul, Helsinki', value: 120 },
    { label: '(UTC+03:00) Moscow, Baghdad', value: 180 },
    { label: '(UTC+05:30) India', value: 330 },
    { label: '(UTC+08:00) Beijing, Perth, Singapore', value: 480 },
    { label: '(UTC+09:30) Adelaide, Darwin', value: 570 },
    { label: '(UTC+10:00) Sydney, Guam', value: 600 },
];

const NtpSettingsModal = ({ device, onClose, onSubmit, isSubmitting }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [settings, setSettings] = useState({
        serverName: '',
        timezoneOffset: 0,
        syncInterval: 1440,
    });
    const effectRan = useRef(false); // 2. Add the ref to track the effect

    useEffect(() => {
        // 3. Add the check to ensure the effect only runs once
        if (effectRan.current === false) {
            const fetchSettings = async () => {
                if (!device) return;
                try {
                    const data = await api.getNtpSettings(device.id);
                    setSettings(data);
                } catch (err) {
                    setError(err.message);
                } finally {
                    setIsLoading(false);
                }
            };
            fetchSettings();
        }
        
        // This cleanup function marks the effect as having run
        return () => {
            effectRan.current = true;
        }
    }, [device]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSettings(prev => ({ ...prev, [name]: name === 'serverName' ? value : parseInt(value, 10) }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(settings);
    };
    
    if (isLoading) return <div className="modal-overlay"><div className="modal-content"><p>Loading NTP Settings...</p></div></div>;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>NTP Server Settings for {device.serial_number}</h2>
                {error && <p style={{ color: 'red' }}>Error: {error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label" htmlFor="serverName">Server Name</label>
                        <input
                            id="serverName"
                            name="serverName"
                            type="text"
                            value={settings.serverName}
                            onChange={handleChange}
                            className="form-input"
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label" htmlFor="timezoneOffset">Timezone (UTC)</label>
                        <select
                            id="timezoneOffset"
                            name="timezoneOffset"
                            value={settings.timezoneOffset}
                            onChange={handleChange}
                            className="form-input"
                        >
                            {timezones.map(tz => (
                                <option key={tz.value} value={tz.value}>{tz.label}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label className="form-label" htmlFor="syncInterval">Auto Sync Interval (minutes)</label>
                        <input
                            id="syncInterval"
                            name="syncInterval"
                            type="number"
                            min="1"
                            value={settings.syncInterval}
                            onChange={handleChange}
                            className="form-input"
                        />
                    </div>
                    <div className="modal-actions">
                        <button type="button" onClick={onClose} className="button button-secondary" disabled={isSubmitting}>
                            Cancel
                        </button>
                        <button type="submit" className="button action-button" disabled={isSubmitting}>
                            {isSubmitting ? 'Saving...' : 'Save Settings'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default NtpSettingsModal;